import React, { useState } from 'react'
import { Button, View } from 'react-native-web'
import { useNavigate } from 'react-router-dom';

const Indicators = () => {
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    const handleQuery = (type) => {
        console.log(`Botón presionado: ${type}`);
        fetch('https://v2-raw.1onesolutions.com/api/get_csv_postgre', {
            method: 'POST',
            headers: {
                'Access-Control-Allow-Origin': '*',
                name_group: 'one_danone',
                type: type,
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Error en la solicitud: ${response.statusText}`);
                }
                return response.text();
            })
            .then(data => {
                // console.log('data', data, typeof data)
                let dataParsed = JSON.parse(data)
                openCsvInNewTab(dataParsed.message, type)
            })
            .catch(error => {
                setError(error.message); // Guardar el mensaje de error en el estado
                console.error(error);
            });
        // Aquí puedes agregar la lógica específica para cada botón
    };


    const openCsvInNewTab = (csvData, type) => {
        // Dividir los datos CSV en filas y celdas
        const usersMap = getUsersMap(csvData);
        const rows = csvData.split('\n');
        const headers = rows[0]?.split(',').map(header => header.replace(/"/g, '').trim());
        const body = rows.slice(1).map((row) => row.split(','));
    
        // Generar la tabla en HTML
        let tableHtml = `<table id="dataTable" border="1" style="width: 100%; text-align: left; border-collapse: collapse;">`;
        if (headers) {
            tableHtml += '<thead><tr>';
            headers.forEach((header) => {
                tableHtml += `<th>${header.replace(/"/g, '')}</th>`;
            });
            tableHtml += '</tr></thead>';
        }
        tableHtml += '<tbody>';
        body.forEach((row) => {
            if (row.length > 1) {
                tableHtml += '<tr>';
                row.forEach((cell) => {
                    tableHtml += `<td>${cell.replace(/"/g, '')}</td>`;
                });
                tableHtml += '</tr>';
            }
        });
        tableHtml += '</tbody></table>';
    
        // Crear el contenido del archivo CSV para descargar
        const csvBlob = new Blob([csvData], { type: 'text/csv' });
        const csvUrl = URL.createObjectURL(csvBlob);
    
        // Abrir una nueva pestaña y escribir la tabla en el HTML
        const newWindow = window.open();
        newWindow.document.write(`
            <html>
                <head>
                    <title>Tabla de Resultados</title>
                    <style>
                        table { font-family: Arial, sans-serif; border-spacing: 0; margin: 20px auto; }
                        th, td { padding: 8px 12px; border: 1px solid #ddd; }
                        th { background-color: #f4f4f4; }
                        .download-btn { display: block; width: 200px; margin: 20px auto; padding: 10px; text-align: center; background-color: #4CAF50; color: white; text-decoration: none; border-radius: 5px; }
                        .download-btn:hover { background-color: #45a049; }
                        .filter-btn { display: block; width: 200px; margin: 20px auto; padding: 10px; text-align: center; background-color: #2196F3; color: white; text-decoration: none; border-radius: 5px; }
                        .filter-btn:hover { background-color: #1E88E5; }
                        /* Estilos para el modal */
                        .modal { display: none; position: fixed; z-index: 1; left: 0; top: 0; width: 100%; height: 100%; overflow: auto; background-color: rgb(0,0,0); background-color: rgba(0,0,0,0.4); }
                        .modal-content { background-color: #fefefe; margin: 15% auto; padding: 20px; border: 1px solid #888; width: 80%; }
                        .close { color: #aaa; float: right; font-size: 28px; font-weight: bold; }
                        .close:hover, .close:focus { color: black; text-decoration: none; cursor: pointer; }
                    </style>
                </head>
                <body>
                    <h1 style="text-align: center;">Resultados para ${type}</h1>
                    <a id="downloadLink" href="${csvUrl}" download="resultados.csv" class="download-btn">Descargar CSV</a>
                    <button class="filter-btn" onclick="openModal()">Filtrar</button>
                    ${tableHtml}
    
                    <!-- Modal -->
                    <div id="filterModal" class="modal">
                        <div class="modal-content">
                            <span class="close" onclick="closeModal()">&times;</span>
                            <h2>Filtrar por Usuario</h2>
                            <select id="userFilter" class="filter-input">
                                <option value="">Todos los Usuarios</option>
                                ${Array.from(usersMap.entries()).map(([userId, userLogin]) => `<option value="${userId}">${userLogin}</option>`).join('')}
                            </select>
                            <button onclick="filterTable()">Aplicar Filtro</button>
                        </div>
                    </div>
    
                    <script>
                        let filteredCsvData = \`${csvData}\`;
    
                        function openModal() {
                            document.getElementById('filterModal').style.display = 'block';
                        }
    
                        function closeModal() {
                            document.getElementById('filterModal').style.display = 'none';
                        }
    
                        function filterTable() {
                            const userFilter = document.getElementById('userFilter').value.toLowerCase();
                            const table = document.getElementById('dataTable');
                            const rows = table.getElementsByTagName('tr');
                            const headers = rows[0].getElementsByTagName('th');
                            let filteredData = [Array.from(headers).map(th => th.textContent).join(',')];
    
                            for (let i = 1; i < rows.length; i++) {
                                const cells = rows[i].getElementsByTagName('td');
                                const userCell = cells[1].textContent.toLowerCase(); // Asumiendo que el usuario está en la segunda columna
                                let display = true;
    
                                if (userFilter && userCell !== userFilter) {
                                    display = false;
                                }
    
                                rows[i].style.display = display ? '' : 'none';
                                if (display) {
                                    filteredData.push(Array.from(cells).map(cell => cell.textContent).join(','));
                                }
                            }
    
                            // Actualizar el CSV filtrado
                            filteredCsvData = filteredData.join('\\n');
                            const filteredCsvBlob = new Blob([filteredCsvData], { type: 'text/csv' });
                            const filteredCsvUrl = URL.createObjectURL(filteredCsvBlob);
                            document.getElementById('downloadLink').href = filteredCsvUrl;
    
                            closeModal();
                        }
                    </script>
                </body>
            </html>
        `);
        newWindow.document.close(); // Finalizar escritura en la nueva pestaña
    };
    // const openCsvInNewTab = (csvData, type) => {
    //     const users = getUniqueUsers(csvData);
    //     console.log('users', users)
    //     // Dividir los datos CSV en filas y celdas
    //     const rows = csvData.split('\n');
    //     const headers = rows[0]?.split(',');
    //     const body = rows.slice(1).map((row) => row.split(','));
    
    //     // Generar la tabla en HTML
    //     let tableHtml = `<table id="dataTable" border="1" style="width: 100%; text-align: left; border-collapse: collapse;">`;
    //     if (headers) {
    //         tableHtml += '<thead><tr>';
    //         headers.forEach((header) => {
    //             tableHtml += `<th>${header.replace(/"/g, '')}</th>`;
    //         });
    //         tableHtml += '</tr></thead>';
    //     }
    //     tableHtml += '<tbody>';
    //     body.forEach((row) => {
    //         if (row.length > 1) {
    //             tableHtml += '<tr>';
    //             row.forEach((cell) => {
    //                 tableHtml += `<td>${cell.replace(/"/g, '')}</td>`;
    //             });
    //             tableHtml += '</tr>';
    //         }
    //     });
    //     tableHtml += '</tbody></table>';
    
    //     // Crear el contenido del archivo CSV para descargar
    //     const csvBlob = new Blob([csvData], { type: 'text/csv' });
    //     const csvUrl = URL.createObjectURL(csvBlob);
    
    //     // Abrir una nueva pestaña y escribir la tabla en el HTML
    //     const newWindow = window.open();
    //     newWindow.document.write(`
    //         <html>
    //             <head>
    //                 <title>Tabla de Resultados</title>
    //                 <style>
    //                     table { font-family: Arial, sans-serif; border-spacing: 0; margin: 20px auto; }
    //                     th, td { padding: 8px 12px; border: 1px solid #ddd; }
    //                     th { background-color: #f4f4f4; }
    //                     .download-btn { display: block; width: 200px; margin: 20px auto; padding: 10px; text-align: center; background-color: #4CAF50; color: white; text-decoration: none; border-radius: 5px; }
    //                     .download-btn:hover { background-color: #45a049; }
    //                     .filter-btn { display: block; width: 200px; margin: 20px auto; padding: 10px; text-align: center; background-color: #2196F3; color: white; text-decoration: none; border-radius: 5px; }
    //                     .filter-btn:hover { background-color: #1E88E5; }
    //                     /* Estilos para el modal */
    //                     .modal { display: none; position: fixed; z-index: 1; left: 0; top: 0; width: 100%; height: 100%; overflow: auto; background-color: rgb(0,0,0); background-color: rgba(0,0,0,0.4); }
    //                     .modal-content { background-color: #fefefe; margin: 15% auto; padding: 20px; border: 1px solid #888; width: 80%; }
    //                     .close { color: #aaa; float: right; font-size: 28px; font-weight: bold; }
    //                     .close:hover, .close:focus { color: black; text-decoration: none; cursor: pointer; }
    //                 </style>
    //             </head>
    //             <body>
    //                 <h1 style="text-align: center;">Resultados para ${type}</h1>
    //                 <a href="${csvUrl}" download="resultados.csv" class="download-btn">Descargar CSV</a>
    //                 <button class="filter-btn" onclick="openModal()">Filtrar</button>
    //                 ${tableHtml}
    
    //                 <!-- Modal -->
    //                 <div id="filterModal" class="modal">
    //                     <div class="modal-content">
    //                         <span class="close" onclick="closeModal()">&times;</span>
    //                         <h2>Filtrar por Usuario</h2>
    //                         <select id="userFilter" class="filter-input">
    //                             <option value="">Todos los Usuarios</option>
    //                             ${users.map(user => `<option value="${user}">${user}</option>`).join('')}
    //                         </select>
    //                         <button onclick="filterTable()">Aplicar Filtro</button>
    //                     </div>
    //                 </div>
    
    //                 <script>
    //                     function openModal() {
    //                         document.getElementById('filterModal').style.display = 'block';
    //                     }
    
    //                     function closeModal() {
    //                         document.getElementById('filterModal').style.display = 'none';
    //                     }
    
    //                     function filterTable() {
    //                         const userFilter = document.getElementById('userFilter').value.toLowerCase();
    //                         const table = document.getElementById('dataTable');
    //                         const rows = table.getElementsByTagName('tr');
    
    //                         for (let i = 1; i < rows.length; i++) {
    //                             const cells = rows[i].getElementsByTagName('td');
    //                             const userCell = cells[1].textContent.toLowerCase(); // Asumiendo que el usuario está en la segunda columna
    //                             let display = true;
    
    //                             if (userFilter && userCell !== userFilter) {
    //                                 display = false;
    //                             }
    
    //                             rows[i].style.display = display ? '' : 'none';
    //                         }
    
    //                         closeModal();
    //                     }
    //                 </script>
    //             </body>
    //         </html>
    //     `);
    //     newWindow.document.close(); // Finalizar escritura en la nueva pestaña
    // };
    // const openCsvInNewTab = (csvData, type) => {
    //     // Dividir los datos CSV en filas y celdas
    //     const rows = csvData.split('\n');
    //     const headers = rows[0]?.split(',');
    //     const body = rows.slice(1).map((row) => row.split(','));
    
    //     // Generar la tabla en HTML
    //     let tableHtml = `<table border="1" style="width: 100%; text-align: left; border-collapse: collapse;">`;
    //     if (headers) {
    //       tableHtml += '<thead><tr>';
    //       headers.forEach((header) => {
    //         tableHtml += `<th>${header.replace(/"/g, '')}</th>`;
    //       });
    //       tableHtml += '</tr></thead>';
    //     }
    //     tableHtml += '<tbody>';
    //     body.forEach((row) => {
    //       if (row.length > 1) { 
    //         tableHtml += '<tr>';
    //         row.forEach((cell) => {
    //           tableHtml += `<td>${cell.replace(/"/g, '')}</td>`;
    //         });
    //         tableHtml += '</tr>';
    //       }
    //     });
    //     tableHtml += '</tbody></table>';
    
    //     // Abrir una nueva pestaña y escribir la tabla en el HTML
    //     const newWindow = window.open();
    //     newWindow.document.write(`
    //       <html>
    //         <head>
    //           <title>Tabla de Resultados</title>
    //           <style>
    //             table { font-family: Arial, sans-serif; border-spacing: 0; margin: 20px auto; }
    //             th, td { padding: 8px 12px; border: 1px solid #ddd; }
    //             th { background-color: #f4f4f4; }
    //           </style>
    //         </head>
    //         <body>
    //           <h1 style="text-align: center;">Resultados para ${type}</h1>
    //           ${tableHtml}
    //         </body>
    //       </html>
    //     `);
    //     newWindow.document.close(); // Finalizar escritura en la nueva pestaña
    //   };

    return (
        <>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <h1>Indicadores</h1>
                <button onClick={() => navigate("/")} style={styles.backButton}>
                    Volver al inicio
                </button>
            </div>
            <div style={styles.gridContainer}>
                {/* <button
                    style={styles.gridButton}
                    onClick={() => handleQuery("list_forms")}
                >
                    Listado de Formularios
                </button> */}
                {/* <button
                    style={styles.gridButton}
                    onClick={() => handleQuery("ventas")}
                >
                    Ventas mensuales
                </button> */}
                <button
                    style={styles.gridButton}
                    onClick={() => handleQuery("forms_historic_p_user")}
                >
                    FORMS HISTORICOS
                </button>
                <button
                    style={styles.gridButton}
                    onClick={() => handleQuery("checkin_details")}
                >
                    CHECKIN DETAIL
                </button>
                {/* <button
                    style={styles.gridButton}
                    onClick={() => handleQuery("clientes")}
                >
                    Clientes activos
                </button>
                <button
                    style={styles.gridButton}
                    onClick={() => handleQuery("ingresos")}
                >
                    Ingresos por trimestre
                </button>
                <button
                    style={styles.gridButton}
                    onClick={() => handleQuery("desempeño")}
                >
                    Desempeño anual
                </button> */}
            </div>
            
        </>
    );
};

// const getUniqueUsers = (csvData) => {
//     const rows = csvData.split(`\n`);
//     const headers = rows[0]?.split(',').map(header => header.replace(/"/g, '').trim());
//     console.log('headers', headers)
//     const userIndex = headers.indexOf('user_id'); // Asume que la columna de usuario se llama 'user_id'
//     const users = new Set();

//     rows.slice(1).forEach((row) => {
//         const cells = row.split(',');
//         if (cells[userIndex]) {
//             users.add(cells[userIndex].replace(/"/g, ''));
//         }
//     });

//     return Array.from(users);
// };

const getUsersMap = (csvData) => {
    const rows = csvData.split('\n');
    const headers = rows[0]?.split(',').map(header => header.replace(/"/g, '').trim());
    console.log('headers', headers)
    const userIdIndex = headers.indexOf('user_id'); // Índice de la columna user_id
    const userLoginIndex = headers.indexOf('user_login'); // Índice de la columna user_login
    if (userIdIndex === -1 || userLoginIndex === -1) {
        console.error('Las columnas user_id o user_login no se encontraron en el CSV.');
        return {};
    }
    const usersMap = new Map();

    rows.slice(1).forEach((row) => {
        const cells = row.split(',');
        const userId = cells[userIdIndex]?.replace(/"/g, '').trim();
        const userLogin = cells[userLoginIndex]?.replace(/"/g, '').trim();
        if (userId && userLogin) {
            usersMap.set(userId, userLogin);
        }
    });

    return usersMap;
};

// Estilos en línea
const styles = {
    backButton: {
        padding: "10px 20px",
        fontSize: "16px",
        backgroundColor: "#007BFF",
        color: "#fff",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
    },
    gridContainer: {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)", // 3 botones por fila
        gap: "20px",
        padding: "20px",
    },
    gridButton: {
        padding: "15px",
        fontSize: "16px",
        backgroundColor: "#4CAF50",
        color: "white",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        textAlign: "center",
    },
};

export default Indicators